import { Argv } from 'yargs'

export const handler = (): null => null
export const command = 'aws <command>'
export const description = 'execute commands related to aws'
export const builder = (yargs: Argv): Argv => yargs.commandDir('aws-commands')
